import React from 'react'
import { Outlet } from 'react-router-dom'
import Footer from '../Compponents/Footer/Footer'
import NavbarAdmin from '../Compponents/NavbarAdmin/NavbarAdmin'

export default function AdminLayout() {
  return (
    <div>
        <NavbarAdmin/>
        <Outlet/>
        <Footer/>
    </div>
  )
}
